class ProductWearItWithNosto extends HHBaseElement {
  constructor() {
    super()
    this.resultId = this.dataset.id
    this.$products = []
    this.$placementID = this.dataset.id
    this.sectionHeadline = this.dataset.sectionHeadline
    this.titleRecommended = ''
    this.$container = this.querySelector('.product-wear-it-with__container')
    this.$titleContainer = this.querySelector('.product-wear-it-with__title')

    this.runNosto = this.runNosto.bind(this)
    this._generateList = this._generateList.bind(this)
    this._generateProductCard = this._generateProductCard.bind(this)
  }

  runNosto() {
    window.__NOSTO_RECOMMENDER__?.getRecommendation().then((response) => {
      if (typeof response.recommendations[this.$placementID] !== 'undefined') {
        this.$products = response.recommendations[
          this.$placementID
        ].products.filter((product) => !product.tags1.includes('free'))
        this.titleRecommended =
          response.recommendations[this.$placementID].title
        this.resultId = response.recommendations[this.$placementID].result_id

        if (this.sectionHeadline) {
          this.$titleContainer.innerHTML = this.sectionHeadline
        } else if (this.titleRecommended) {
          this.$titleContainer.innerHTML = this.titleRecommended
        }
        if (this.$products.length > 0) {
          this.buildBlock()
        } else {
          this.remove()
        }
      } else {
        this.remove()
      }
    })
  }

  buildBlock() {
    this.$container.innerHTML = ''

    const wrapperElem = document.createElement('div')
    wrapperElem.className =
      'product-wear-it-with__items flex flex-direction-column'
    wrapperElem.innerHTML = this._generateList()

    this.$container.appendChild(wrapperElem)
  }

  _generateList() {
    const productsList = this.$products.map(this._generateProductCard)

    return `${productsList.join('')}`
  }

  _generateProductCard(item, key) {
    const variantId = item?.recommended_sku?.id || item.product_id
    return `
      <product-card
        class="product-card-small product-card-medium background-color-warm-white"
        hydrate
        data-id="${variantId}"
        product-handle="${item.url.split('/').slice(-1)}"
        card-size='medium'
        url-postfix='nosto=${this.resultId}'
      ></product-card>
    `
  }

  connectedCallback() {
    this.runNosto()
    this.addEventListener('click::add-to-cart', (event) => {
      window.__NOSTO_RECOMMENDER__?.trackAddToCart(
        event.detail.product_id,
        this.resultId
      )
    })

    this.addEventListener('click::quick-shop-toggle', (event) => {
      window.__NOSTO_RECOMMENDER__?.trackProductView(
        event.detail.product_id,
        this.resultId
      )
    })
  }
}

window.customElements.define(
  'product-wear-it-with-nosto',
  ProductWearItWithNosto
)
